import React, { useState } from "react";
import { useAnimals } from "@/lib/repo";
import { Input } from "@/components/ui/input";
import { Search as SearchIcon } from "lucide-react";
import { AnimalListRow } from "@/components/AnimalListRow";

export default function Search() {
  const [q, setQ] = useState("");
  const results = useAnimals(q.length >= 2 ? { q, limit: 50 } : {});
  const loading = false;

  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight">Búsqueda rápida</h1>
        <p className="text-sm text-muted-foreground">Por chip RFID, número de lomo o tatuaje de oreja.</p>
      </div>
      <div className="relative">
        <SearchIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid="global-search-input" autoFocus value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Empezá a tipear…" className="h-12 pl-10 text-base" />
      </div>
      <div className="space-y-2">
        {!loading && q.length >= 2 && results.length === 0 && <p className="text-sm text-muted-foreground">Sin resultados.</p>}
        {q.length >= 2 && results.map((a) => <AnimalListRow key={a.id} animal={a} />)}
      </div>
    </div>
  );
}
